import React from 'react';
import { motion } from 'framer-motion';

const features = [
  { title: 'Transparent Pricing', desc: 'No hidden fees. Upfront, clear pricing for all materials.' },
  { title: 'Access to Credit', desc: 'Flexible credit options for qualified developers.' },
  { title: 'Assured Timelines', desc: 'On-time delivery, every time. We value your project schedule.' },
  { title: 'Quality Materials', desc: 'Sourced from trusted brands, with strict quality checks.' },
];

const WhyChoose = () => (
  <motion.section
    className="max-w-5xl mx-auto py-10 md:py-16 px-2 md:px-4"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.8, ease: 'easeOut' }}
  >
    <h2 className="text-xl md:text-2xl font-bold text-center text-primary mb-8 md:mb-10">Why Choose Houzzdat</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
      {features.map((f, i) => (
        <div key={i} className="bg-white rounded-xl shadow-soft p-4 md:p-6 flex flex-col items-start">
          <h3 className="text-base md:text-lg font-semibold text-accent mb-2">{f.title}</h3>
          <p className="text-primary text-sm md:text-base">{f.desc}</p>
        </div>
      ))}
    </div>
  </motion.section>
);

export default WhyChoose; 